export const SERVER = "https://soccerstore.onrender.com"
// export const SERVER = "http://0.0.0.0:8000"